import {createPortal} from "react-dom";

const Portal = ({children}) => {
    return createPortal(children, document.getElementById("popup"));
};

export default Portal;